import Container from '@framework/di/Container';
import EvercallDashboardExitRepository from './repository/EvercallDashboardExitRepository';

/** Temporary solution to perform force logout to handle tricky cases: FIN-23438 */
const forceLogoutFromEvercallDashboard = async (
  container: Container,
  payload: { corporateEmail: string, dashboardId: string },
) => {
  const repository = container.get<EvercallDashboardExitRepository>(EvercallDashboardExitRepository);
  await repository.forceLogoutFromDashboard(payload);
};

export default forceLogoutFromEvercallDashboard;
